import { render } from "./CheckOtherTicket.vue?vue&type=template&id=4d231c89"
import script from "./CheckOtherTicket.vue?vue&type=script&lang=js"
export * from "./CheckOtherTicket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__